import { BASE_FLOW_BLOCK_TYPE_COMPATIBILITY } from './baseFlowCompatibility.js';
import { FLOW_TEMPLATE_BLOCK_TYPE_COMPATIBILITY } from './flowTemplateCompatibility.js';
import { SKILL_V2_BLOCK_TYPE_COMPATIBILITY } from './skillV2Compatibility.js';
import {
  type FlowDefinitionBlockCompatibilityByBlockType,
  FlowDefinitionBlockTypeCompatibility,
} from './types.js';
import { type AnyBlockType, FlowKind } from '../base/baseSchema.js';

function getBlockCompatibility(
  blockCompatibilitiesByBlockType: FlowDefinitionBlockCompatibilityByBlockType
) {
  const requiredBlockTypes = new Set<AnyBlockType>();

  for (const [blockType, compatibility] of Object.entries(blockCompatibilitiesByBlockType)) {
    if (compatibility === FlowDefinitionBlockTypeCompatibility.Required) {
      requiredBlockTypes.add(blockType as AnyBlockType);
    }
  }

  return {
    blockCompatibilitiesByBlockType,
    requiredBlockTypes,
  };
}

export const BLOCK_COMPATIBILITY_BY_FLOW_KIND: Record<
  FlowKind,
  {
    blockCompatibilitiesByBlockType: FlowDefinitionBlockCompatibilityByBlockType;
    requiredBlockTypes: Set<AnyBlockType>;
  }
> = {
  [FlowKind.Base]: getBlockCompatibility(BASE_FLOW_BLOCK_TYPE_COMPATIBILITY),
  [FlowKind.FlowTemplate]: getBlockCompatibility(FLOW_TEMPLATE_BLOCK_TYPE_COMPATIBILITY),
  [FlowKind.Skill]: getBlockCompatibility(SKILL_V2_BLOCK_TYPE_COMPATIBILITY),
};
